module.exports = __webpack_public_path__ + "img/img_page_06_01.b4ec4b34.png";